import React, { FC } from 'react';
import { Button } from '@mui/material';
import useAuthentication from '@hooks/useAuthentication';

interface LogoutButtonProps {
}

const LogoutButton: FC<LogoutButtonProps> = () => {
    const { logout } = useAuthentication();

    return (
        <Button
            data-testid="LogoutButton"
            onClick={() => logout()}
        >
            Log Out
        </Button>
    );
};

export default LogoutButton;
